import type { Svarsutrymme } from '../types'

/** Renderar en uppgifts definierade svarsutrymme — tomma skrivrader, numrerade
 *  svarsplatser eller en öppen svarsruta — så som det ska se ut vid utskrift.
 *  Kryssrutor (flerval) renderas i alternativlistan, inte här, och 'inget'
 *  ger inget utrymme alls. */
export default function SvarsutrymmeVy({ svarsutrymme }: { svarsutrymme: Svarsutrymme }) {
  if (svarsutrymme.typ === 'rader') {
    return (
      <div className="svarsutrymme" aria-hidden="true">
        {Array.from({ length: svarsutrymme.antal ?? 3 }, (_, i) => (
          <div key={i} className="svarsrad" />
        ))}
      </div>
    )
  }

  if (svarsutrymme.typ === 'numrerad_lista') {
    return (
      <div className="svarsutrymme" aria-hidden="true">
        {Array.from({ length: svarsutrymme.antal ?? 3 }, (_, i) => (
          <div key={i} className="svarsrad svarsrad-numrerad">
            <span>{i + 1}.</span>
          </div>
        ))}
      </div>
    )
  }

  if (svarsutrymme.typ === 'ruta') {
    return <div className="svarsutrymme svarsruta" aria-hidden="true" />
  }

  return null
}
